import { useNavigate } from "react-router-dom";

const LoginButton = ({ redirectURL, type, title }: any) => {
  const navigate = useNavigate();

  const handleRedirectToLogin = () => {
    const params = window.location.href.split("?")[1];
    const hasRedirectURL =
      redirectURL !== null && redirectURL !== undefined && redirectURL !== "";

    navigate(hasRedirectURL ? `/?${params}` : "/");
  };

  return (
    <>
      {type == "FLOATING" ? (
        <button
          style={{ color: "var(--primary)" }}
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-slate-100 hover:text-accent-foreground h-9 px-4 py-2 absolute right-4 top-4 md:right-8 md:top-8 "
          onClick={handleRedirectToLogin}
        >
          { title ?? "Login"}
        </button>
      ) : (
        <button
          style={{ color: "var(--primary)" }}
          onClick={handleRedirectToLogin}
        >
          { title ?? "Login now"}
        </button>
      )}
    </>
  );
};

export default LoginButton;
